module.exports = __webpack_public_path__ + "img/care.77507fcd.png";